export default __webpack_public_path__ + "static/Into-Go-016525282e2249aeb748a78d0eb9728a.webp";